import React from 'react'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import { mergeStyles } from '@enlyt/helpers/mergeStyles'

const ResultItem = ({ style, loading, iconGray, title, value, subTitle, date, isLast, loadingText, iconSize = 20 }) => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, style)
  return (
    <div style={isLast ? styles.dataContainer : styles.dataContainerWithBorder} >
      <span style={{ ...styles.iconData, ...{ height: iconSize, width: iconSize } }}>{iconGray}</span>
      <div style={styles.dataTitleContainer} >
        {value
          ? <div style={styles.dataTitleAndDate}>
              <div style={styles.dataTitle}>{title}</div>
              <div style={styles.dateText}>{date}</div>
            </div>
          : <div style={styles.dataTitle}>{title}</div>
        }
        <div className="ellipsisText" style={styles.dataSubTitle}>{loading && !value ? loadingText : value}</div>
        <div className="ellipsisText" style={styles.dataSubTitle}>{loading && !subTitle ? loadingText : subTitle}</div>
      </div>
      {!value && <div style={styles.dateText}>{date}</div>}
    </div>
  )
}

export default ResultItem
